import {
  CalendarRef,
  ConnectionCalendar,
  ExternalConnection,
} from '@griply/types';

// Setting the default clears it on the other connections, but that write spans documents and
// cannot be transactional (transactions fail offline), so a lost race can leave two holders.
// Sorting by id first makes both platforms land on the same one instead of on whichever the
// snapshot happened to deliver first.
const byId = (a: ExternalConnection, b: ExternalConnection) =>
  a.id.localeCompare(b.id);

// The single source of the "which calendar does a new event go on" rule. Both platforms call
// this — deriving it anywhere else is how web and mobile drift apart on the same account.
export const getDefaultEventCalendar = (
  connections: ExternalConnection[],
  selectableCalendars: ConnectionCalendar[],
): CalendarRef | null => {
  const configured = [...connections].sort(byId).flatMap((connection) => {
    const calendarId = connection.settings?.defaultCalendar;
    if (!calendarId) {
      return [];
    }

    return selectableCalendars.filter(
      (calendar) =>
        calendar.connectionId === connection.id && calendar.id === calendarId,
    );
  });

  // A default that no longer resolves — calendar deleted, turned read-only, account removed —
  // falls through to the name-sorted first entry rather than leaving the form without a target.
  const [target] = configured.length ? configured : selectableCalendars;
  if (!target) {
    return null;
  }

  return { connectionId: target.connectionId, calendarId: target.id };
};
